import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {makeStyles, useTheme, Paper, Typography} from '@material-ui/core';
import arrowDown from "../../../images/downArrow.png";
import arrowUp from '../../../images/upArrow.png';
import CountUp from 'react-countup';
import {themeTypeToBool} from '../../../utils/helpers';
import ScopeSelect from './ScopeSelect';
import {TooltipRight} from "../../Common/CustomTooltips";
import t from "../../../languages/pl";

const useStyles = makeStyles(theme => ({
    container: {
        minWidth: 350,
        height: 130,
        margin: theme.spacing(1),
        background: theme.palette.background.paper,
        position: "relative"
    },
    title: {
        padding: 15,
        paddingBottom: 5
    },
    content: {
        paddingLeft: theme.spacing(2),
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-start"
    },
    mainInfo: {
        fontWeight: 600,
        color: themeTypeToBool(theme.palette.type) ? "#6075DD" : "#FFD1A4"
    },
    barChart: {
        width: "30%",
        position: "absolute",
        right: 15,
        bottom: 10
    },
    balanceDiv: {
        paddingTop: 10,
        paddingLeft: 15,
        height: "40%"
    },
    arrowImg: {
        height: "0.9em"
    },
    balanceValue: {
        fontWeight: 500,
        width: 70,
        cursor: "pointer"
    },
    settingsIcon: {
        position: "absolute",
        top: 10,
        right: 10,
        padding: 0,
    }
}));

const periodOptions = [
    {
        name: t.ecoHigh,
        period: t.ecoPeriodHigh,
        value: 'eco_wysokie'
    }, {
        name: t.ecoMedium,
        period: t.ecoPeriodMedium,
        value: 'eco_srednie'
    },
    {
        name: t.ecoLow,
        period: t.ecoPeriodLow,
        value: 'eco_niskie'
    },
];

function CountEcoValue(props) {
    const theme = useTheme();
    const classes = useStyles(theme);
    const {
        decimals,
        units,
        barChartImg,
        data,
    } = props;

    const [valueToDisplay, setValue] = useState(1);
    const [balance, setBalance] = useState("");
    const [period, setPeriod] = useState(periodOptions[0]);
    const [title, setTitle] = useState("");
    const [startValue, setStartValue] = useState(0);

    useEffect(() => {
        setTitle(`${capitalize(t.monthly)} km ${period.name}`);
        setValue(parseInt(data[period.value].eco));
        setBalance(cutUnit(data[period.value].eco_procent));
    }, [data, period.name, period.value]);

    const cutUnit = (data) => {
        if (data != null)
            return parseInt(data.slice(0, data.length - 1));
    };

    const capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const handlePeriodChange = (period) => {
        setStartValue(valueToDisplay);
        setPeriod(period);
        setTitle(`${capitalize(t.monthly)} km ${period.name}`);
        setValue(parseInt(data[period.value].eco));
        setBalance(cutUnit(data[period.value].eco_procent));
    };

    return (
        <Paper className={classes.container} square>
            <Typography variant="subtitle2" className={classes.title}>
                {title}
            </Typography>
            <div className={classes.content}>
                <Typography variant="h4" className={classes.mainInfo}>
                    <CountUp
                        start={startValue}
                        end={valueToDisplay}
                        duration={5}
                        decimals={decimals}
                        decimal=","
                    />
                </Typography>
                &nbsp;
                <Typography variant="h5" className={classes.mainInfo} style={{paddingBottom: 2}}>
                    {units}
                </Typography>
            </div>
            <div className={classes.balanceDiv}>
                <img
                    src={barChartImg}
                    className={classes.barChart}
                    alt="barChartImg"
                />
                <TooltipRight title={t.deviationFromPreviousPeriod}>
                    <Typography variant="subtitle2"
                                className={classes.balanceValue}
                                style={{color: (balance > 0) ? "#3CC480" : "#FF6161"}}
                    >
                        <img
                            src={balance > 0 ? arrowUp : arrowDown}
                            className={classes.arrowImg}
                            alt="arrowImg"
                        />
                        &nbsp;
                        {Math.abs(balance)}%
                    </Typography>
                </TooltipRight>
            </div>
            <ScopeSelect
                className={classes.settingsIcon}
                value={period}
                onChange={handlePeriodChange}
                buttonOptions={periodOptions}
            />
        </Paper>
    );
}

export default CountEcoValue;

CountEcoValue.propTypes = {
    data: PropTypes.object,
    decimals: PropTypes.number,
    units: PropTypes.string,
    barChartImg: PropTypes.node,
    averageMileage: PropTypes.bool,
    averageDriveTime: PropTypes.bool,
    combustionForFleet: PropTypes.bool,
};
